// extracted by mini-css-extract-plugin
export var black = "_3o-6";
export var brand = "_3o-1";
export var ddefault = "_3o-0";
export var error = "_3o-3";
export var gray = "_3o-2";
export var highContrast = "_3o-8";
export var outline = "_3o-7";
export var success = "_3o-5";
export var warning = "_3o-4";